export const utilConstants = {
    SET_LOADER: 'SET_LOADER'
}